import styled from "styled-components";
import { DIAGNOSTICS_MEDIA } from "@/constants/diagnostics";

export const StyledArrows = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: fixed;
  right: 80px;
  bottom: 40px;
  @media ${DIAGNOSTICS_MEDIA.md} {
    display: none;
  }
`;

export const StyledArrow = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  transition: all var(--transition-fast);
  &:active {
    transform: scale(0.95);
  }
  &:hover {
    transform: scale(1.05);
  }
`;

export const StyledPlaceholder = styled.div`
  height: 50px;
`;
